import axios from "axios";
import * as d3 from "d3";
import {colonAnnotation, numberFormat, responsivefy, tooltip_class} from '../functions'

export default function (chart, divId, vizName, symbol) {
    console.log("Chart vizName called:", vizName)
    axios.all([
        axios({url: '/json/geojsonfiles/India_States.json', baseURL: '', method: 'GET'}),
        //  axios({ url: '/json/forewarn_data_heatmap.json', baseURL: '', method: 'GET' }),
        //  axios({ url: '/json/revenue_by_state.json', baseURL: '', method: 'GET' })

        axios.get('/api/bank-map-data-metrics'),

    ]).then(axios.spread(function (r0, r1) {

        //Assigning to the variables from axios output
        var topo = r0.data;
        var loandata = r1.data;

        //Mapping the required variables from above dataset using nest functions
        var datanest = d3.nest()
            .key(function (d) {
                return d.stateUpper;
            })
            .rollup(function (v) {
                return d3.sum(v, function (d) {
                    return d.loanAmount
                })
            })
            .map(loandata);

        // Data and color scale
        var dataRev = d3.map(datanest)


        //created for the scale domain 	by mapping the cost and revenue
        let loss = loandata.map(function (d) {
            return d.loanLossAmount
        })

        let balance = loandata.map(function (d) {
            return d.loanBalance
        })

        //Blue color scale Need to parameterize the domain values from metrics
        var x1AxisLabel = d3.scaleLinear()
            .domain([Math.min(...balance), Math.max(...balance)])
            .range(['#2897bf', '#081d58']);

        //Green color scale Need to parameterise the domain values from metrics
        var x2AxisLabel = d3.scaleLinear()
            .domain([0, d3.max(dataRev.values())])
            .range(['#ecf8fa', '#00441b']);

        //Red color scale Need to parameterise the domain values from metrics
        var x3AxisLabel = d3.scaleLinear()
            .domain([Math.min(...loss), Math.max(...loss)])
            .range(['#e65339', '#7f0000']);


        //Circle radius scale for Blue circles Need to parameterise the domain values
        var radiusBlue = d3.scaleSqrt()
            .domain([Math.min(...balance), Math.max(...balance)])
            .range([11, 20]);

        //Circle radius scale for red circles Need to parameterise the domain values
        var radiusRed = d3.scaleSqrt()
            .domain([Math.min(...loss), Math.max(...loss)])
            .range([5, 15]);

        function responsivefylabel(svg) {
            var container = d3.select(svg.node().parentNode),
                width = parseInt(svg.style('width')),
                height = parseInt(svg.style('height')),
                aspect = width / height;

            svg.attr('viewBox', '0 0 ' + width + ' ' + height)
                .attr('perserveAspectRatio', 'xMinYMid')
                .call(resize)

            //d3.select(window).on('resize.' + container.attr('id'), resize)
            window.addEventListener("resize", resize)

            function resize() {
                var targetWidth = parseInt(container.style('width'))
                svg.attr('width', targetWidth / 2)
                svg.attr('height', Math.round(targetWidth / 2 / aspect))
            }
        }

        function responsivefylegend(svg) {
            var container = d3.select(svg.node().parentNode),
                width = parseInt(svg.style('width')),
                height = parseInt(svg.style('height')),
                aspect = width / height;

            svg.attr('viewBox', '0 0 ' + width + ' ' + height)
                .attr('perserveAspectRatio', 'xMinYMid')
                .call(resize)

            window.addEventListener("resize", resize)

            function resize() {
                var targetWidth = parseInt(container.style('width'))
                svg.attr('width', targetWidth / 2)
                svg.attr('height', Math.round(targetWidth / 6.5 / aspect))
            }
        }

        if (symbol == true) {
            //Declaring to remove the existed s
            svg = d3.selectAll("svg").remove();

            // // The svg assigning the declared html element in the html
            var svg = d3.select(divId)
                .append("svg")
                .attr("width", chart.width) // getting the width of the svg
                .attr("height", chart.height) // getting the height of svg
                .attr("width", "100%")
                .call(responsivefy)

            d3.select(".d3-tip" + divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
            let y1tip = tooltip_class()

            y1tip.attr('class', 'd3-tip' + divId.id)
                .html((d) => {
                    return "State" + colonAnnotation + d.properties.state_name
                })

            svg.call(y1tip);

            //Declaring the projection for the map
            var projection = d3.geoMercator()
                .fitExtent([[0, 0], [chart.width - 400, chart.height]], topo);

            //Assigning the projection scale into the path
            var path = d3.geoPath().projection(projection);

            // Draw the map
            svg.append("g")
                .selectAll("path")
                .data(topo.features) // passing the geojson array of features
                .enter()
                .append("path") //passing the path variable here to draw the map outline
                .style("stroke", "black") //outline color tobe black
                .attr("fill", function (d) {
                    d.loan_by_state = dataRev.get(d.properties.state_name) || 0; //Getting the revenue by statename from Datarev array
                    return x2AxisLabel(d.loan_by_state); //Filling the states based on the revenue
                })
                .attr("d", path)
                // on the same path
                /*  .on('click', function (d) { // function for clicked element
                d3.select('.selected').classed('selected', false)
                d3.select(this).classed('selected', true)
                stateMap(d.properties.state_name) //by clicking it will directs to function with a parameter name
           })*/
                .on("mouseover", y1tip.show)
                .on("mouseout", y1tip.hide)
            //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

            //Creating a circle container using g element of svg
            var circles = svg.selectAll("g").data(loandata).enter();

            //Displaying City, Revenue, Cost and Margin on the tooltip
            d3.select(".d3-tipmap" + divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
            let y2tip = tooltip_class()

            y2tip.attr('class', 'd3-tipmap' + divId.id)
                .html((d) => {
                    return (
                        "State" + colonAnnotation + d.stateLower + "<br/>" + "<span style= 'color:green'>"
                        + "Loan Amount" + colonAnnotation + numberFormat(d.loanAmount) + "</span>" + "<br/>"
                        + "<span style ='color:blue'> " + " Loan Balance" + colonAnnotation + numberFormat(d.loanBalance) + "</span>"
                        + "<br/>" + "<span style ='color:red'> " + "Loan Loss AMount" + colonAnnotation + numberFormat(d.loanLossAmount)
                    )
                })

            svg.call(y2tip);

            circles.append("circle")  //Appending the blue circle on map
                .attr("cx", function (d) {
                    return projection([d.long, d.lat])[0]; //Fetching the lat long and assigning long to cx variable
                })
                .attr("cy", function (d) {
                    return projection([d.long, d.lat])[1]; //Fetching the lat long and assigning the lat to cy variable
                })
                .attr("r", function (d) {
                    return radiusBlue(d.loanBalance / 2);
                }) //Sizing the circle radius to revenue
                .attr("fill", function (d) {
                    return x1AxisLabel(d.loanBalance);
                }) // Filling the color with revenue
                .style("opacity", 0.85)

            circles.append("circle") //Appending the red circle on map
                .attr("cx", function (d) {
                    return projection([d.long, d.lat])[0]; //Fetching the lat long and assigning long to cx variable
                })
                .attr("cy", (d) => {
                    return projection([d.long, d.lat])[1]
                }) //Fetching the lat long and assigning the lat to cy variable
                .attr("r", (d) => {
                    return radiusRed(d.loanLossAmount);
                }) //Sizing the circle radius to cost
                .attr("fill", (d) => {
                    return x3AxisLabel(d.loanLossAmount);
                })  // Filling the color with cost
                .style("opacity", 0.85)
                .on("mouseover", y2tip.show)
                .on("mouseout", y2tip.hide)

            // Add the label for the bubble
            svg.selectAll(".city-label")
                .data(loandata)
                .enter()
                .append("text")
                .attr("class", "city-label")
                .attr("x", (d) => {
                    return projection([d.long, d.lat])[0]
                })
                .attr("y", (d) => {
                    return projection([d.long, d.lat])[1]
                })
                .text((d) => {
                    return d.city
                })
                .attr("dx", 10) //Moving the label little to right
                .attr("dy", 5) //Moving the label littlt to belows

            //sort bars based on value
            var topstate = loandata.sort(((a, b) => b.loanAmount - a.loanAmount)).slice(0, 3)

            topstate.sort(function (a, b) {
                return d3.ascending(a.loanAmount, b.loanAmount);
            })

            var topstatelabel = d3.select(divId).append("svg")
                .attr("width", 500)
                .attr("height", 200)
                .call(responsivefylabel)
                .attr("class", "toplabel")
                .append("g")
                .attr("transform", "translate(250,10)")

            var x1Scale = d3.scaleLinear()
                .range([0, 500])
                .domain([0, d3.max(topstate, (d) => {
                    return d.loanAmount
                })]);

            var y1Scale = d3.scaleBand()
                .range([90, 0], .1)
                .domain(topstate.map((d) => {
                    return d.stateLower
                }));

            //make y axis to show bar names
            var y1AxisLabel = d3.axisLeft(y1Scale).tickSize(0)

            var gy = topstatelabel
                .append("g")
                .attr("class", "gyaxis")
                .call(y1AxisLabel)
                .selectAll("text")
                .attr("y", -4)
                .attr("x", -10)
                .style("text-anchor", "end");

            console.warn(gy)

            var bars = topstatelabel.selectAll(".bar")
                .data(topstate)
                .enter()
                .append("g")

            //append rects
            bars.append("rect")
                .attr("class", "bar")
                .attr("y", (d) => {
                    return y1Scale(d.stateLower);
                })
                .attr("height", y1Scale.bandwidth() / 2)
                .attr("x", 0)
                .attr("width", (d) => {
                    return x1Scale(d.loanAmount) / 3
                })
                .attr("fill", (d) => {
                    return x2AxisLabel(d.loanAmount)
                })


            //add a value label to the right of each bar
            bars.append("text")
                .attr("class", "label")
                //y position of the label is halfway down the bar
                .attr("y", (d) => {
                    return y1Scale(d.stateLower) + y1Scale.bandwidth() / 3 + 4
                })
                //x position is 3 pixels to the right of the bar
                .attr("x", (d) => {
                    return x1Scale(d.loanAmount) / 3 + 3
                })
                .text((d) => {
                    return numberFormat(d.loanAmount)
                })
                .style('font-size', '10px');
        }

        //for drawing the legend.we are declaring the domains with scale
        var green = d3.scaleLinear().domain(x2AxisLabel.domain()).range([200, 0])

        //Axis declaration for legend
        var greenAxis = d3.axisRight(green).ticks(10).tickFormat(numberFormat)

        //creating legend for the state wise heatmap color
        //creating the key variable for legend scale
        var key = d3.select(divId)
            .append("svg")
            .attr("width", 120)
            .attr("height", 215)
            .call(responsivefylegend)
            .attr("class", "legend-map")

        //creating the color legend and appending to key
        var y2legend = key.append("defs")
            .append("svg:linearGradient")
            .attr("id", "gradient")
            .attr("x1", "100%")
            .attr("y1", "0%")
            .attr("x2", "100%")
            .attr("y2", "100%")
            .attr("spreadMethod", "pad")

        //appending the high color to legend
        y2legend.append("stop")
            .attr("offset", "0%")
            .attr("stop-color", '#00441b')
            .attr("stop-opacity", 1);

        //appending the low color to legend
        y2legend.append("stop")
            .attr("offset", "100%")
            .attr("stop-color", '#ecf8fa')
            .attr("stop-opacity", 1);

        //appending the rectangle legend to the key scale
        key.append("rect")
            .attr("width", 20)
            .attr("height", 214)
            .style("fill", "url(#gradient)")
            .attr("transform", "translate(0,10)");

        //calling the axis scale legend and append to the key
        key.append("g")
            .attr("class", "y axis")
            .attr("transform", "translate(21,10)")
            .call(greenAxis)
    }))
}
